import React from 'react';
import PropTypes from 'prop-types';
import {
  Container, Input, LabelContainer, Text,
} from './css';

const Checkbox = ({
  input,
  label,
  defaultChecked,
  tooltip,
  multiple,
  separator,
  options,
  disabled = false,
}) => {
  if (multiple) {
    if (options && options.length) {
      return (
        options.map((option, index) => {
          let isChecked = (input.value.indexOf(option.value) >= 0);
          if (separator) {
            isChecked = false;
            const values = option.value.split(separator);
            values.forEach((item) => {
              if (input.value.indexOf(item) > -1) {
                isChecked = true;
              }
            });
          }

          return (
            <Container key={index}>
              <LabelContainer>
                <Input
                  type="checkbox"
                  value={option.value}
                  checked={isChecked}
                  disabled={option.disabled}
                  onChange={(event) => {
                    const newValues = [...input.value];
                    if (event.target.checked) {
                      if (separator) {
                        const opt = option.value.split(separator);
                        opt.forEach((item) => newValues.push(item));
                      } else {
                        newValues.push(option.value);
                      }
                    } else if (separator) {
                      const opt = option.value.split(separator);
                      opt.forEach((item) => {
                        newValues.splice(newValues.indexOf(item), 1);
                      });
                    } else {
                      newValues.splice(newValues.indexOf(option.value), 1);
                    }

                    return input.onChange(newValues);
                  }}
                />
                <Text disabled={option.disabled}>{option.label}</Text>
              </LabelContainer>
              {tooltip && tooltip}
            </Container>
          );
        })
      );
    }

    return null;
  }

  return (
    <Container>
      <LabelContainer>
        <Input
          {...input}
          checked={input.value}
          type="checkbox"
          defaultChecked={defaultChecked}
          disabled={disabled}
        />
        <Text>{label}</Text>
      </LabelContainer>
      {tooltip && tooltip}
    </Container>
  );
};

Checkbox.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  label: PropTypes.node,
  defaultChecked: PropTypes.bool,
  tooltip: PropTypes.node,
  multiple: PropTypes.bool,
  separator: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      disabled: PropTypes.bool,
    }),
  ),
  disabled: PropTypes.bool,
};

export default Checkbox;
